import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
export var mapRouteReferencePoints = function mapRouteReferencePoints(referencePoints) {
  return referencePoints.reduce(function (acc, point) {
    if (!point) {
      return acc;
    }
    if (typeof point === 'string') {
      return [].concat(_toConsumableArray(acc), [point]);
    }
    if (Array.isArray(point)) {
      return [].concat(_toConsumableArray(acc), [point]);
    }
    if (point.getCoordinates) {
      var coordinates = point.getCoordinates();
      return coordinates ? [].concat(_toConsumableArray(acc), [coordinates]) : acc;
    }
    return acc;
  }, []);
};